import React, { useMemo } from 'react';
import LinkModel from '../../Types/LinkModel';
import LinkListCardModel from '../../Types/LinkListCardModel';
import Button from '../../Components/Button';
import { StyledLinkListSection } from './Styles/LinkList-block.styling';

interface LinkListBlockModel {
    title: string;
    link: LinkModel;
    linksPerRow: number;
    allowThumbnails: boolean;
    links: LinkListCardModel[];
}

const LinkListBlock = (props: LinkListBlockModel) => {
    const { title, link, linksPerRow, allowThumbnails, links } = props;

    let cells = useMemo(() => {
        switch (linksPerRow) {
            case 2:
                return 'cells-2';
            case 3:
                return 'cells-3';
            case 4:
                return 'cells-4';
        }
    }, [linksPerRow]);

    return (
        <StyledLinkListSection className="link-list-block section">
            <div className="link-list-block__header">
                {title && title != "" &&
                    <h2 className="link-list-block__title">{title}</h2>
                }
                {link?.href && link.href != "" &&
                    <Button
                        btnSize="medium"
                        btnType="outlined"
                        onClick={() => window.location.href = link.href}
                        className="additional__btn"
                    >
                        {link.text}
                    </Button>
                }
            </div>
            <ul className={`link-list-block__list grid ${cells}`}>
                {links.map((linkCard, idx) => (
                    <li className="link-list-block__list--item" key={linkCard.text + idx}>
                        {allowThumbnails && linkCard.imageUrl && linkCard.imageUrl != "" && <img className="link-list-block__image" src={linkCard.imageUrl} alt={linkCard.imageAlt} />}
                        {linkCard.title && linkCard.title != "" && <h5>{linkCard.title}</h5>}
                        {linkCard.text && linkCard.text != "" && <div dangerouslySetInnerHTML={{ __html: linkCard.text }} ></div>}
                        {linkCard.link?.text && linkCard.link.text != "" && linkCard.link.href && linkCard.link.href != "" &&
                            <a href={linkCard.link.href} className="link-list-block__list--item__link">
                                {linkCard.link.text}
                            </a>
                        }
                    </li>
                ))}
            </ul>
        </StyledLinkListSection>
    );
};

export default LinkListBlock;
